
<template>

    <div :class=" tabClasses " @click=" toggleTab() ">

        <h3 class="tab-price" >${{ totalTicketAmount.toFixed( 2 ) }}</h3>
        <h3>MY CART</h3>
        <h3 class="tab-count">{{ currentTab.length }}</h3>
    </div>

</template>

<script>

    import { mapGetters, mapActions } from 'vuex';

    export default {

        name: 'tab-bar',
        computed: {

            ...mapGetters({

                totalTicketAmount : 'orderTab/getCost',
                currentTab        : 'orderTab/currentTab',
                tabOpen           : 'orderTab/tabOpen',
                currentRoute      : 'currentRoute'
            }),
            tabClasses: function(){

                const base = [ 'tab-bar' ];
                base.push( ( this.tabOpen ) ? 'tab-bar-opened' : 'tab-bar-closed' );

                return base.join( ' ' );
            }
        },
        methods: {

            ...mapActions({

                toggleTab : 'orderTab/toggleTab'
            })
        }
    }

</script>

<style scoped>

    .tab-bar {

        display: flex;
        justify-content: space-between;
        align-items: center;

        background-color: rgb(58, 37, 37);
        color: #ccc;

        width: 100%;
        height: 55px;

        box-sizing: border-box;
        position: fixed;
        z-index: 250;
        padding: 0px 10px;
        left: 0;
        right: 0;

        transition: bottom 0.3s ease-in;
    }
    .tab-bar-opened {

        bottom: 65px;
    }
    .tab-bar-closed {

        bottom: 0px;
    }

    .tab-bar > h3 {

        margin: 0;
        padding: 0;
    }
    .tab-count {

        cursor: pointer;
        border: 2px solid #fff;
        width: 25px;
        text-align: center;
    }

</style>